import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BASE_URL = 'https://hub.bertolitours.pt';

const DEFAULT_SEO = {
    title: 'Bertoli HUB | Portal de cursos',
    description: 'Portal de cursos da Bertoli HUB.',
    robots: 'index, follow'
};

const SEO_BY_ROUTE = [
    {
        match: (pathname) => pathname === '/',
        title: 'Dashboard | Bertoli HUB',
        description: 'Acompanhe os principais conteudos e novidades da plataforma Bertoli HUB.'
    },
    {
        match: (pathname) => pathname === '/modules',
        title: 'Modulos | Bertoli HUB',
        description: 'Explore todos os modulos de aprendizagem disponiveis no Bertoli HUB.'
    },
    {
        match: (pathname) => pathname.startsWith('/module/'),
        title: 'Modulo | Bertoli HUB',
        description: 'Detalhes e progresso do modulo selecionado no Bertoli HUB.'
    },
    {
        match: (pathname) => pathname === '/materials',
        title: 'Materiais | Bertoli HUB',
        description: 'Veja os materiais e conteudos de apoio disponiveis na plataforma.'
    },
    {
        match: (pathname) => pathname.startsWith('/material/'),
        title: 'Material | Bertoli HUB',
        description: 'Acesse um material especifico da plataforma Bertoli HUB.'
    },
    {
        match: (pathname) => pathname === '/news',
        title: 'Noticias | Bertoli HUB',
        description: 'Acompanhe novidades e comunicados no Bertoli HUB.'
    },
    {
        match: (pathname) => pathname.startsWith('/news/'),
        title: 'Noticia | Bertoli HUB',
        description: 'Leia uma noticia publicada no Bertoli HUB.'
    },
    {
        match: (pathname) => pathname === '/community',
        title: 'Comunidade | Bertoli HUB',
        description: 'Interaja com a comunidade da plataforma Bertoli HUB.'
    },
    {
        match: (pathname) => pathname === '/login',
        title: 'Login | Bertoli HUB',
        description: 'Entre no portal de cursos Bertoli HUB.',
        robots: 'noindex, nofollow'
    },
    {
        match: (pathname) => pathname === '/recover-password',
        title: 'Recuperar senha | Bertoli HUB',
        description: 'Recupere o acesso da sua conta Bertoli HUB.',
        robots: 'noindex, nofollow'
    },
    {
        match: (pathname) => ['/unauthorized', '/api-unavailable', '/not-found'].includes(pathname),
        title: 'Bertoli HUB',
        description: 'Portal de cursos da Bertoli HUB.',
        robots: 'noindex, nofollow'
    }
];

function upsertMetaTag(attributeName, attributeValue, content) {
    const selector = `meta[${attributeName}="${attributeValue}"]`;
    let meta = document.head.querySelector(selector);

    if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(attributeName, attributeValue);
        document.head.appendChild(meta);
    }

    meta.setAttribute('content', content);
}

function upsertCanonical(href) {
    let canonical = document.head.querySelector('link[rel="canonical"]');

    if (!canonical) {
        canonical = document.createElement('link');
        canonical.setAttribute('rel', 'canonical');
        document.head.appendChild(canonical);
    }

    canonical.setAttribute('href', href);
}

function getSeoConfig(pathname) {
    const routeConfig = SEO_BY_ROUTE.find((entry) => entry.match(pathname));
    return routeConfig ? { ...DEFAULT_SEO, ...routeConfig } : DEFAULT_SEO;
}

function Seo() {
    const location = useLocation();
    const { pathname } = location;

    useEffect(() => {
        const seo = getSeoConfig(pathname);
        const canonicalUrl = `${BASE_URL}${pathname}`;

        document.title = seo.title;

        upsertMetaTag('name', 'description', seo.description);
        upsertMetaTag('name', 'robots', seo.robots);
        upsertMetaTag('name', 'googlebot', seo.robots);

        upsertMetaTag('property', 'og:title', seo.title);
        upsertMetaTag('property', 'og:description', seo.description);
        upsertMetaTag('property', 'og:type', 'website');
        upsertMetaTag('property', 'og:url', canonicalUrl);
        upsertMetaTag('property', 'og:site_name', 'Bertoli HUB');

        upsertMetaTag('name', 'twitter:card', 'summary');
        upsertMetaTag('name', 'twitter:title', seo.title);
        upsertMetaTag('name', 'twitter:description', seo.description);

        upsertCanonical(canonicalUrl);
    }, [pathname]);

    return null;
}

export default Seo;
